import { CARAVAN_TRIP } from '../../config/trip'
import { AgendaRepository, type AgendaEvent, type AgendaEventInput } from '../../data/local/agendaRepository'
import { caravanDb, syncNow } from '../../services/syncRuntime'

export class AgendaService {
  readonly #repository: AgendaRepository

  constructor(repository: AgendaRepository) {
    this.#repository = repository
  }

  list(): Promise<AgendaEvent[]> {
    return this.#repository.list()
  }

  get(id: string): Promise<AgendaEvent | null> {
    return this.#repository.get(id)
  }

  async create(input: AgendaEventInput): Promise<AgendaEvent> {
    validateAgendaInput(input)
    const event = await this.#repository.create({
      ...input,
      title: input.title.trim(),
      place: input.place.trim(),
    })
    if (navigator.onLine) void syncNow()
    return event
  }

  async update(id: string, input: AgendaEventInput, baseVersion: number): Promise<AgendaEvent> {
    validateAgendaInput(input)
    const event = await this.#repository.update(id, input, baseVersion)
    if (navigator.onLine) void syncNow()
    return event
  }

  async delete(event: AgendaEvent): Promise<void> {
    await this.#repository.delete(event.id, event.tripId, event.version)
    if (navigator.onLine) void syncNow()
  }
}

function validateAgendaInput(input: AgendaEventInput): void {
  if (input.date < CARAVAN_TRIP.startsOn || input.date > CARAVAN_TRIP.endsOn) throw new Error('Date hors du voyage Maroc.')
  if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/u.test(input.time)) throw new Error('Heure invalide.')
  if (input.title.trim().length < 1 || input.title.trim().length > 100) throw new Error('Titre invalide.')
  if (input.place.trim().length > 120) throw new Error('Lieu trop long.')
}

export const agendaService = new AgendaService(new AgendaRepository(caravanDb))
